module.exports = __webpack_public_path__ + "static/img/gl.2490aa08.svg";